import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { controlFlowProblems } from '../../data/practice/controlFlowProblems';
import ProblemLayout from '../../components/ProblemLayout';

// Default code template based on problem
const getDefaultCode = (problemId: string) => {
  const problem = controlFlowProblems.find(p => p.id === problemId);
  if (!problem) return '';
  
  switch (problem.id) {
    case 'cf-1':
      return `// Nested Loop Pattern
// Write a function to print the following pattern:
// *
// **
// ***
// ****
// *****

function printPattern(n) {
  // Your code here
}

// Test your solution
printPattern(5);`;
    case 'cf-2':
      return `// Conditional Array Processing
// Write a function that processes an array of numbers:
// - Sum all even numbers
// - Multiply all odd numbers
// Return an object with {evenSum, oddProduct}

function processArray(arr) {
  // Your code here
}

// Test your solution
console.log(processArray([1, 2, 3, 4, 5]));`;
    case 'cf-3':
      return `// Recursive Fibonacci with Memoization
// Implement a memoized version of the Fibonacci function
// to avoid redundant calculations

function fibonacci(n, memo = {}) {
  // Your code here
}

// Test your solution
console.log(fibonacci(10));`;
    case 'cf-4':
      return `// Stack-based Expression Evaluator
// Evaluate a mathematical expression with proper operator precedence
// Example: "3 + 4 * 2" should evaluate to 11, not 14

function evaluateExpression(expression) {
  // Your code here
}

// Test your solution
console.log(evaluateExpression("3 + 4 * 2"));`;
    case 'cf-5':
      return `// Queue-based Level Order Traversal
// Implement level-order traversal of a binary tree using a queue

class TreeNode {
  constructor(val) {
    this.val = val;
    this.left = null;
    this.right = null;
  }
}

function levelOrderTraversal(root) {
  // Your code here
}

// Test your solution
const root = new TreeNode(1);
root.left = new TreeNode(2);
root.right = new TreeNode(3);
root.left.left = new TreeNode(4);
root.left.right = new TreeNode(5);
console.log(levelOrderTraversal(root));`;
    case 'cf-6':
      return `// Loop-based Matrix Rotation
// Rotate a square matrix 90 degrees clockwise in-place

function rotateMatrix(matrix) {
  // Your code here
}

// Test your solution
const matrix = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9]
];
rotateMatrix(matrix);
console.log(matrix);`;
    case 'cf-7':
      return `// String Processing with Conditionals
// Count the occurrences of each character in a string
// Ignore spaces and make the count case-insensitive

function countCharacters(str) {
  // Your code here
}

// Test your solution
console.log(countCharacters("Hello World"));`;
    case 'cf-8':
      return `// Object Manipulation with Loops
// Deep clone an object with nested structures
// Handle arrays, objects, and primitive values

function deepClone(obj) {
  // Your code here
}

// Test your solution
const original = {
  a: 1,
  b: { c: 2, d: [3, 4, { e: 5 }] }
};
const cloned = deepClone(original);
console.log(cloned);`;
    case 'cf-9':
      return `// Array Processing with Multiple Loops
// Find all unique triplets in an array that sum to zero
// Avoid duplicate triplets

function findTriplets(arr) {
  // Your code here
}

// Test your solution
console.log(findTriplets([-1, 0, 1, 2, -1, -4]));`;
    case 'cf-10':
      return `// Complex Conditional Logic
// Implement a function to validate a Sudoku board
// Check rows, columns, and 3x3 boxes

function isValidSudoku(board) {
  // Your code here
}

// Test your solution
const board = [
  ["5","3",".",".","7",".",".",".","."],
  ["6",".",".","1","9","5",".",".","."],
  [".","9","8",".",".",".",".","6","."],
  ["8",".",".",".","6",".",".",".","3"],
  ["4",".",".","8",".","3",".",".","1"],
  ["7",".",".",".","2",".",".",".","6"],
  [".","6",".",".",".",".","2","8","."],
  [".",".",".","4","1","9",".",".","5"],
  [".",".",".",".","8",".",".","7","9"]
];
console.log(isValidSudoku(board));`;
    default:
      return `// Write your solution here
function solution() {
  // Your code here
}

// Test your solution
solution();`;
  }
};

const ControlFlowProblem: React.FC = () => {
  const { problemId } = useParams<{ problemId: string }>();
  const problem = controlFlowProblems.find(p => p.id === problemId);
  const [code, setCode] = useState(problem?.starterCode || '');

  if (!problem) {
    return <div>Problem not found</div>;
  }

  return (
    <ProblemLayout
      title={problem.title}
      difficulty={problem.difficulty}
      tags={problem.tags}
      description={problem.description}
      hints={problem.hints}
      code={code}
      onCodeChange={setCode}
      onResetCode={() => setCode(problem.starterCode || '')}
      backUrl="/practice/control-flow"
      problemId={problemId || ''}
    />
  );
};

export default ControlFlowProblem;